import { createFileRoute } from '@tanstack/react-router';
import { withModalOutlet } from '../-withModalOutlet';
import Users from '../../../administration/src/components/MetaSites/MetaSiteDetails/Permissions/Users';

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit')({
  component: withModalOutlet(Users),
});
